import { render, staticRenderFns } from "./classifyHotel5.vue?vue&type=template&id=39699f69"
import script from "./classifyHotel5.vue?vue&type=script&lang=ts"
export * from "./classifyHotel5.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports